import styled from "styled-components";

const H2 = styled.h2`
  font-family: "Pacifico", cursive;
  font-weight: 1;
  text-align: center;
  font-size: 36px;
  margin-bottom: 70px;
`;

const H2LARGER = styled.h2`
  font-family: "Pacifico", cursive;
  font-weight: 1;
  text-align: center;
  font-size: 48px;
`;

const H2SMALL = styled.h2`
  font-family: "Pacifico", cursive;
  font-weight: 1;
  text-align: center;
  font-size: 24px;
  margin-bottom: 70px;
`;
const P = styled.p`
  font-family: "Roboto", sans-serif;
`;

const H3 = styled.h3`
  font-family: "Thasadith";
  font-size: 24px;
`;
const H3SMALL = styled.h3`
  font-family: "Thasadith";
  font-size: 15px !important;
`;

const INTERPRETATION = styled.span`
  font-family: "Thasadith";
  font-weight: 500;
  font-size: 24px;
`;

export { H2, H2LARGER, H3, H3SMALL, H2SMALL, INTERPRETATION, P };
